import { DrawerProps, DrawerType, DrawerTypes, setDrawerClose, setDrawerOpen } from '../drawer'
import { RootPageState } from '../../../redux/types'
import { useDispatch } from 'react-redux'
import { usePageSelector } from '../../../hooks/usePageSelector'

interface DrawerHookReturn {
  drawerOpen: boolean
  props?: DrawerProps
  setOpen(props?: DrawerProps): void
  setClose(): void
}

export function useDrawer(drawerType: DrawerTypes): DrawerHookReturn {
  const dispatch = useDispatch()
  const { drawers } = usePageSelector((state: RootPageState) => {
    return {
      drawers: state.drawerReducer.drawers
    }
  })
  const drawerObj = drawers?.find(
    (drawer: { type: DrawerTypes; props?: DrawerProps }) => drawer.type === drawerType
  )

  const setOpen = (props?: DrawerProps): void => {
    dispatch(setDrawerOpen({ type: drawerType, ...(props && { props }) }))
  }
  const setClose = (): void => {
    dispatch(setDrawerClose(drawerType))
  }

  return {
    drawerOpen: Boolean(drawerObj?.open),
    setClose,
    setOpen,
    ...(drawerObj?.props && { props: drawerObj.props })
  }
}

export function useIsDrawerOpen(drawerType: DrawerTypes): boolean {
  const { drawers } = usePageSelector((state: RootPageState) => {
    return {
      drawers: state.drawerReducer.drawers
    }
  })
  const drawerObj = drawers?.find((drawer: DrawerType) => drawer.type === drawerType)

  return Boolean(drawerObj?.open)
}

export function useGetOpenDrawers(): Partial<Record<DrawerTypes, boolean>> {
  const { drawers } = usePageSelector((state: RootPageState) => {
    return {
      drawers: state.drawerReducer.drawers
    }
  })
  const drawerObj = drawers?.reduce((acc, val) => ({ ...acc, [val.type]: val.open }), {})

  return drawerObj
}

export function useOpenDrawerProps(): DrawerProps | null {
  const { drawers } = usePageSelector((state: RootPageState) => {
    return {
      drawers: state.drawerReducer.drawers
    }
  })

  return drawers?.find((val: DrawerType) => val.open)?.props || null
}
